module.exports = __webpack_public_path__ + "img/3650436.3b09fa9a.jpg";